import React from 'react';
import { Edit2, Star, Trash } from 'iconsax-react';
import Chip from '../atoms/Chip';
import classNames from 'classnames';

export type severity = 'success' | 'error' | 'warning' | 'primary' | 'default';
interface props {
  date?: string;
  title: string;
  description?: string;
  link?: string;
  isEditable?: boolean;
  isDelete?: boolean;
  suspended: boolean;
  status?: string;
  statusSeverity?: severity;
  onEdit?: () => void;
  onDelete?: () => void;
  onSetDefault?: () => void;
  addionalInfo?: React.ReactElement;
  titleSize?: string;
  dataTestId?: string;
}

export default function MainCardItem({
  title,
  date,
  description,
  isDelete,
  isEditable,
  suspended,
  link,
  onEdit,
  onDelete,
  onSetDefault,
  status,
  statusSeverity,
  addionalInfo,
  titleSize,
  dataTestId,
}: props) {
  return (
    <div className="card-main-item max-w-full" data-testid={dataTestId}>
      {status && (
        <Chip className="my-2" type={statusSeverity as severity}>
          {status}
        </Chip>
      )}
      <div className="item-details flex justify-between items-center">
        <div className="item-contant">
          <p className="text-sm font-normal leading-6 text-text-secondary">
            {date}
          </p>
          <h3
            className={classNames(
              'text-lg leading-7 text-light-text-primary dark:!text-dark-text-primary font-semibold break-all',
              titleSize
            )}
          >
            {title}
          </h3>
          {link && (
            <p className="text-blue-800 text-sm font-normal break-all">
              <a target="_blank" href={link}>
                {link}
              </a>
            </p>
          )}
          {description && (
            <p className="text-sm leading-6 font-normal text-text-secondary break-all">
              {description}
            </p>
          )}
        </div>
        <div className="item-actions flex gap-4">
          {onSetDefault && (
            <button
              type="button"
              onClick={onSetDefault}
              disabled={suspended}
              data-testid="main-card-item-set-default-btn"
              className={`bg-[#FFFBF0] p-2 w-8 h-8 rounded-full flex justify-center items-center
      ${suspended ? 'cursor-not-allowed' : 'cursor-pointer hover:scale-105 duration-200 ease-in-out'}`}
            >
              <Star size={16} color={suspended ? '#A9A9A9' : '#F5A623'} />
            </button>
          )}
          {isEditable && (
            <button
              type="button"
              onClick={onEdit}
              disabled={suspended}
              data-testid="main-card-item-edit-btn"
              className={`bg-[#F3F6FD] p-2 w-8 h-8 rounded-full flex justify-center items-center 
      ${
        suspended
          ? 'cursor-not-allowed'
          : 'cursor-pointer hover:scale-105 duration-200 ease-in-out'
      }`}
            >
              <Edit2 color={suspended ? '#A9A9A9' : '#3C91E6'} />
            </button>
          )}

          {isDelete && (
            <button
              type="button"
              onClick={onDelete}
              disabled={suspended}
              data-testid="main-card-item-delete-btn"
              className={`bg-[#FAF2F3] p-2 w-8 h-8 rounded-full flex justify-center items-center 
      ${
        suspended
          ? 'cursor-not-allowed'
          : 'cursor-pointer hover:scale-105 duration-200 ease-in-out'
      }`}
            >
              <Trash color={suspended ? '#A9A9A9' : '#CC2936'} />
            </button>
          )}
        </div>
      </div>
      {addionalInfo}
    </div>
  );
}
